<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增用户</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="username" label="用户名" align="center" />
      <el-table-column prop="company_name" label="所属公司" align="center" />
      <el-table-column
        prop="last_login_address"
        label="登录地址"
        align="center"
      />
      <el-table-column
        prop="last_login_at"
        label="最后登录时间"
        align="center"
      />
      <el-table-column prop="created_at" label="创建时间" align="center" />
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success" size="mini"
            >运行</el-tag
          >
          <el-tag v-if="scope.row.status == 0" type="danger" size="mini"
            >停运</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="500" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
          <el-button
            @click.native.prevent="giveUser(scope.row)"
            type="success"
            size="small"
            icon="el-icon-edit"
          >
            分配角色
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="title"
      :visible.sync="userOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getuserout"
    >
      <el-form ref="userform" :model="userform" label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="分配角色">
              <el-select
                v-model="userform.roles_ids"
                multiple
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="userSubmit">确 定</el-button>
        <el-button @click="getuserout">取 消</el-button>
      </div>
    </el-dialog>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24" v-if="actionType !== 'edit'">
            <el-form-item label="用户名">
              <el-input
                v-model="form.username"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="userId == form.id || userId == '1'">
            <el-form-item label="用户密码">
              <el-input
                v-model="form.password"
                autocomplete="off"
                placeholder="请输入"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24" v-if="userId == form.id || userId == '1'">
          <el-form-item label="重复密码">
            <el-input
              v-model="form.confirm_password"
              autocomplete="off"
              placeholder="请输入"
              show-password
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="所属公司">
            <el-select
              v-model="form.company_id"
              placeholder="请选择"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in companysList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="用户状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio
                v-for="item in regionTypes"
                :label="item.label"
                :key="item.label"
                >{{ item.text }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

  <script>
import tableCommon from "../../../mixins/table-common";
import {
  getuserList,
  assignmentUser,
  addUser,
  deleteUser,
  editUser,
} from "../../api/user";
import { getCompanysList } from "../../api/userMG";
import { getroleList } from "../../api/role";
import { getUserInfo } from "../../api/userMG";
export default {
  mixins: [tableCommon],
  data() {
    return {
      options: [],
      value1: [],
      value2: [],
      // 所属公司
      companysList: [],
      regionTypes: [
        {
          label: 1,
          text: "正常",
        },
        {
          label: 0,
          text: "停用",
        },
      ],
      // 分配角色
      userform: {},
      // 请求地址api
      api: {
        list: getuserList,
        add: addUser,
        del: deleteUser,
        edit: editUser,
      },
      // 规则验证
      rules: {
        username: [{ required: true, message: "请输入名称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        confirm_password: [
          { required: true, message: "请重复密码", trigger: "blur" },
        ],
        company_id: [
          { required: true, message: "请选择公司", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      //分配角色字段
      userOpen: false,
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      // 提交参数
      subForm: {},
      tableData: [],
      // 比对用户密码id
      userId: "",
    };
  },
  mounted() {
    this.getroleLists();
    this.getCompanysLists();
    this.getUserInfos();
  },
  methods: {
    // 获取个人信息
    getUserInfos() {
      getUserInfo().then((res) => {
        this.userId = res.data.user.id;
      });
    },
    // 公司下拉
    getCompanysLists() {
      const form = {
        select: 1,
      };
      getCompanysList(form).then((res) => {
        this.companysList = res.data.records;
      });
    },
    // 请求角色数据
    getroleLists() {
      getroleList().then((res) => {
        console.log(res)
        var userList = res.data.records;
        var newUserlist = [];
        userList.filter((res) => {
          let users = {
            id: res.id,
            name: res.name,
          };
          newUserlist.push(users);
        });
        this.options = newUserlist;
      });
    },
    // 分配角色
    giveUser(res) {
      console.log(res)
      this.title = "分配角色";
      this.userform = JSON.parse(JSON.stringify(res));
      this.userOpen = true;
    },
    // 分配角色点击确定
    userSubmit() {
      const dpUserform = {
        id: this.userform.id,
        userParam: {
          roles_ids: this.userform.roles_ids,
        },
      };
      assignmentUser(dpUserform).then((res) => {
        if (res.code == 200) {
          this.$message.success("分配成功！");
          this.userOpen = false;
          this.initList();
        } else {
          this.$message.error("分配失败！");
        }
      });
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
      this.userform = {
        roles_ids: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增用户";
      this.reset();
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      // this.subForm = {
      //   username: this.form.username,
      //   password: this.form.password,
      //   confirm_password: this.form.confirm_password,
      //   status: this.form.status,
      //   id: this.form.id,
      // };
      // console.log(this.subForm);
      this.handleEdit();
    },
    // 关闭分配用户弹窗
    getuserout() {
      this.userOpen = false;
      this.$refs.userform.clearValidate();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    // 修改用户确定按钮
    submitForms() {
      delete this.form.company_name;
      delete this.form.roles;
      delete this.form.roles_ids;
      delete this.form.status_text;
      delete this.form.type;
      this.submitForm();
      // const subForm = {
      //   username: this.form.username,
      // };
      // console.log(subForm);
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue